import { ProfileCompletionFlowStep } from '../../../types/profileCompletionFlow';
import { ProfileCompletionStepsConfig } from '../../../types/ProfileCompletionStep';
import { StudentSponsorshipApplication } from '../../../types/sponsorshipApplication';
import { SponsorshipOpportunityType } from '../../../types/sponsorshipOpportunity';
import {
  EducationInfoFormStep,
  FinancingInfoFormStep,
  PersonalInformationStep,
  ProfileSignAgreementStep,
} from '../../modal/profileCompletionModal/steps';
import ProfileStartSignAgreementStep from '../../modal/profileCompletionModal/steps/ProfileStartSignAgreementStep';

export const getProfileFlowStepsConfig = (
  sponsorshipApplication: StudentSponsorshipApplication,
  enrollmentStatus: boolean | null,
): ProfileCompletionStepsConfig => {
  const steps: ProfileCompletionStepsConfig = {
    [ProfileCompletionFlowStep.APPLICATION_ACCEPTED]: {
      key: 0,
      title: 'Congratulations! 🎉',
      description: `${sponsorshipApplication?.partner_name || 'Your employer'} has approved your application. You just need to confirm a few details and sign your loan repayment agreement. Then it's official!`,
      component: ProfileStartSignAgreementStep,
    },
    [ProfileCompletionFlowStep.PERSONAL_INFO_FORM]: {
      key: 1,
      title: 'Your Personal Information',
      description: 'Review your contact information to make sure it is complete and correct. If anything is missing, please add it now!',
      component: PersonalInformationStep,
    },
    [ProfileCompletionFlowStep.EDUCATION_INFO_FORM]: {
      key: 2,
      title: 'Your Education Information',
      description: 'Please add any missing information to confirm your enrollment. If you haven\'t finalized your school yet - that\'s okay! You can come back to sign your agreement once you\'ve officially enrolled.',
      component: EducationInfoFormStep,
      show: (application) => application?.derived_application_type === SponsorshipOpportunityType.UPSKILL && !enrollmentStatus,
    },
    [ProfileCompletionFlowStep.FINANCING_INFO_FORM]: {
      key: 3,
      title: 'Your Student Loan Financing',
      description: 'We need to know a bit about your student loans to best set you up for your repayment benefit.',
      component: FinancingInfoFormStep,
    },
    [ProfileCompletionFlowStep.SIGN_AGREEMENT]: {
      key: 4,
      title: 'Let\'s make it official!',
      description: 'You just need to sign your loan repayment agreement. When you\'re about to graduate, Clasp will notify you to sync your eligible student loans to facilitate your repayment benefit. For now - there\'s nothing to do but sign and celebrate! 🥳',
      component: ProfileSignAgreementStep,
    },
  };

  return Object.entries(steps).reduce((acc, [ key, step ]) => {
    if (!step.show || step.show(sponsorshipApplication)) {
      acc[key] = step;
    }

    return acc;
  }, {} as ProfileCompletionStepsConfig);
};
